import { List, ListItem, Text } from "@chakra-ui/react";

export function ErrorList({ errors }: { errors?: string[] }) {
  if (!errors?.length) return null;

  return (
    <List color="red.500" ml={4} styleType="disc">
      {errors.map((error) => (
        <ListItem key={error}>
          <Text>{error}</Text>
        </ListItem>
      ))}
    </List>
  );
}
